import { useState } from 'react';
import { Button, Drawer, Input, Typography, message } from 'antd';
import { LinkOutlined, CopyOutlined } from '@ant-design/icons';
import { useMutation } from '@tanstack/react-query';
import { api } from '../api/client';
import { useDrawerWidth } from '../hooks/useIsMobile';

interface Props {
  userId: string;
  displayName: string;
}

/** 產生「綁定連結」：傳給使用者，對方用任一 provider 登入後即綁到此帳號。 */
export default function BindLinkButton({ userId, displayName }: Props) {
  const drawerWidth = useDrawerWidth(480);
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState<string | null>(null);

  const gen = useMutation({
    mutationFn: () => api.userBindLink(userId),
    onSuccess: (d) => {
      setUrl(d.url);
      setOpen(true);
    },
    onError: (e: Error) => message.error(e.message),
  });

  return (
    <>
      <Button size="small" icon={<LinkOutlined />} loading={gen.isPending} onClick={() => gen.mutate()}>
        產生綁定連結
      </Button>
      <Drawer title={`綁定連結：${displayName}`} open={open} onClose={() => setOpen(false)} width={drawerWidth}>
        <Typography.Paragraph type="secondary" className="text-sm">
          把此連結傳給使用者，對方用任一方式（LINE / Google / Yahoo）登入後，
          該登入就會綁定到此帳號（7 天內有效）。
        </Typography.Paragraph>
        {url && (
          <Input.Search
            value={url}
            enterButton={<CopyOutlined />}
            onSearch={() => {
              navigator.clipboard.writeText(url);
              message.success('已複製');
            }}
          />
        )}
      </Drawer>
    </>
  );
}
